import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { BodyshopState } from "./bodyshopTypes";

export const useBodyshopReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.bodyshop);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<BodyshopState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<BodyshopState>;
};
